import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    artlisttype:0,
    userInfo: {
      
    },
    unique_code:"",
    searchInput: {
      key: "",
      val: ""
    }
  },
  mutations: {
    setUserInfo(state, setUserInfo,unid) { //设置用户信息
      // setUserInfo.auth_type = 2
      state.userInfo = setUserInfo; 
    },
    unique_code(state,unique_code) { //设置用户唯一标示
      state.unique_code=unique_code
    },
    // 关键词key
    keyset(state, id) {
      console.log(state)
      state.searchInput.key = id
    },
    // 关键词
    valset(state, id) {
      state.searchInput.val = id
    },
    setimgstoy(state,id){
      console.log(id)
      state.artlisttype = id
    },
    loginTimeout(state,id){//登录超时处理方法

    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js